export default "__VITE_ASSET__D_RsEPKy__"